// api.js or a separate file
import { resetSessionTimer } from './SessionManager';

// Save the original fetch function
const originalFetch = window.fetch;

// API(s) to exclude from session reset
const excludedApis = [
  'MYSIGN/V1/verifyDocument','MYSIGN/getOtpforVerification', 'api.ipify.org', 'MYSIGN/userRegister', 'MYSIGN/V2/getCorpDetails', 'MYSIGN/getCorpDetails' , 'MYSIGN/V2/getTemplateGrps', 'MYSIGN/getkey', 'MYSIGN/V2/loginValidate', 'MYSIGN/userRegister', 'MYSIGN/regValidateOtp', 'MYSIGN/validateOtp', 'MYSIGN/getOtp', 'MYSIGN/loginValidate', 'MYSIGN/forgotPassword', 'MYSIGN/getOtpForgotPassword', 'MYSIGN/updateServices', 'MYSIGN/getSubscriptionLists', 'MYSIGN/getCaptchaCode', 'MYSIGN/V2/INAPP/mpsCreateJobsV2', 'MYSIGN/generatePDFfromTemplate', 'MYSIGN/mpsGetGuestAccessV2', 'MYSIGN/generateOtpforMobAccess', 'MYSIGN/inbox/downloadFile', 'MYSIGN/getTermsAndConditions', 'MYSIGN/V2/getSignedDoc', 'MYSIGN/inbox/viewFile', 'MYSIGN/V2/mpsGetGuestAccess', 'MYSIGN/generatedscaccesscode', 'MYSIGN/generatedscaccesscodeV2', 'MYSIGN/viewSignedFile', 'MYSIGN/digilocker/makedigilockercall','MYSIGN/getOtpForLogin' 
];

window.fetch = async (...args) => {
    const url = typeof args[0] === 'string' ? args[0] : args[0].url;

    // console.log(url);

    // Check if the API is in the excluded list
    if (!excludedApis.some(excluded => url.includes(excluded))) {
        resetSessionTimer();
    }

    try {
        const response = await originalFetch(...args);
        return response;
    } catch (error) {
        console.error('Fetch error:', error);
        throw error;
    }
};